// Display order for a medicine line's withholding periods (tilbakeholdsperioder).
//
// The stored array has no fixed order: the Animalia drug data lists Slakt/Produkt in
// varying order per preparation, a type the vet adds by hand is appended at the end
// (addMedicine.js addRetentionPeriode), and a clinic standard merged on top appends
// any missing type last (mergeRetentionPeriods). So the same drug could show Slakt on
// top on one line and at the bottom on the next (TICKET-01759).
//
// This helper only affects rendering. It returns a NEW array of { period, index } so
// callers can still address the original array position (remove buttons), and never
// touches the input. Order: Slakt, then Produkt, then anything else in stored order.

const TYPE_ORDER = ['slakt', 'produkt'];

function typeRank(period) {
    const type = String(period?.type || '').toLowerCase();
    const rank = TYPE_ORDER.indexOf(type);
    return rank === -1 ? TYPE_ORDER.length : rank;
}

export function sortRetentionPeriodsForDisplay(retentionPeriods) {
    if (!Array.isArray(retentionPeriods)) {
        return [];
    }
    return retentionPeriods
        .map((period, index) => ({ period, index }))
        .filter(entry => entry.period)
        .sort((a, b) => (typeRank(a.period) - typeRank(b.period)) || (a.index - b.index));
}
